/**
 * hela.ts — Categoría "Heladería y Postres" (10 productos con recetas reales).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_hela",
  skuPrefix: "HEL",
  categoria: "Heladería y Postres",
} as const;

export const cat_hela_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Helado de Vainilla",
    marca: "Casa",
    costo: 0,
    precio: 7500,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "copa",
    ubicacionFisica: "Congelador H1, helados",
    proveedor: "Producción propia",
    tiempoEntrega: "Inmediato",
    descripcionLarga:
      "Helado artesanal de vainilla Madagascar, cremoso, elaborado en casa con leche entera y crema natural. Servido en copa con galleta.",
    especificaciones: [
      { clave: "Sabor", valor: "Vainilla Madagascar" },
      { clave: "Porción", valor: "150g" },
    ],
    imageKeywords: ["vanilla-ice-cream", "helado-vainilla", "dessert"],
    color: "bg-amber-100",
    shape: "circle",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 8,
    recetaIngredientes: [
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 500,
        unidadUso: "ml",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 200,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 150,
        unidadUso: "g",
      },
      {
        nombre: "Huevos AA Kikes x30",
        cantidadCompra: 30,
        unidadCompra: "unidad",
        costoCompra: 14500,
        cantidadUso: 3,
        unidadUso: "unidad",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Helado de Fresa",
    marca: "Casa",
    costo: 0,
    precio: 8500,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "copa",
    ubicacionFisica: "Congelador H1, helados",
    proveedor: "Producción propia",
    tiempoEntrega: "Inmediato",
    descripcionLarga:
      "Helado de fresa con trozos reales de fruta fresca, cremoso y vibrante. Equilibrio perfecto entre dulzor y acidez natural.",
    especificaciones: [{ clave: "Sabor", valor: "Fresa natural" }],
    imageKeywords: ["strawberry-ice-cream", "helado-fresa", "pink-dessert"],
    color: "bg-pink-400",
    shape: "circle",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 8,
    recetaIngredientes: [
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 500,
        unidadUso: "ml",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 200,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 150,
        unidadUso: "g",
      },
      {
        nombre: "Fresa Fresca 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 4800,
        cantidadUso: 300,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Malteada de Chocolate",
    marca: "Casa",
    costo: 0,
    precio: 11500,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "vaso",
    ubicacionFisica: "Barra de helados",
    proveedor: "Producción propia",
    tiempoEntrega: "3 min",
    descripcionLarga:
      "Malteada espesa de helado con leche y jarabe de chocolate belga. Decorada con crema batida y trocitos de galleta.",
    especificaciones: [{ clave: "Volumen", valor: "500ml" }],
    imageKeywords: ["chocolate-milkshake", "malteada", "dessert-drink"],
    color: "bg-amber-900",
    shape: "square",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 250,
        unidadUso: "ml",
      },
      {
        nombre: "Leche Condensada La Lechera 395g",
        cantidadCompra: 395,
        unidadCompra: "g",
        costoCompra: 6200,
        cantidadUso: 50,
        unidadUso: "g",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 50,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 25,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Crepes con Frutas",
    marca: "Casa",
    costo: 0,
    precio: 15500,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "plato",
    ubicacionFisica: "Cocina, preparación al momento",
    proveedor: "Producción propia",
    tiempoEntrega: "10 min",
    descripcionLarga:
      "Dos crepes rellenos de crema pastelera, fresas, banano y chorreado de leche condensada. Acompañados de helado de vainilla.",
    especificaciones: [
      { clave: "Unidades", valor: "2 crepes" },
      { clave: "Tiempo prep", valor: "10 min" },
    ],
    imageKeywords: ["fruit-crepes", "crepe-postre", "pancakes-fruit"],
    color: "bg-amber-400",
    shape: "circle",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Harina de Trigo Haz de Oros 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 4500,
        cantidadUso: 80,
        unidadUso: "g",
      },
      {
        nombre: "Huevos AA Kikes x30",
        cantidadCompra: 30,
        unidadCompra: "unidad",
        costoCompra: 14500,
        cantidadUso: 2,
        unidadUso: "unidad",
      },
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 150,
        unidadUso: "ml",
      },
      {
        nombre: "Fresa Fresca 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 4800,
        cantidadUso: 100,
        unidadUso: "g",
      },
      {
        nombre: "Banano Común 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 1600,
        cantidadUso: 120,
        unidadUso: "g",
      },
      {
        nombre: "Leche Condensada La Lechera 395g",
        cantidadCompra: 395,
        unidadCompra: "g",
        costoCompra: 6200,
        cantidadUso: 40,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Waffles con Helado",
    marca: "Casa",
    costo: 0,
    precio: 14500,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "plato",
    ubicacionFisica: "Cocina, preparación al momento",
    proveedor: "Producción propia",
    tiempoEntrega: "10 min",
    descripcionLarga:
      "Waffle belga recién hecho, bola de helado de vainilla, frutas rojas frescas y chorreado de chocolate caliente.",
    especificaciones: [{ clave: "Porción", valor: "1 waffle + 1 bola" }],
    imageKeywords: ["waffle-icecream", "belgian-waffle", "dessert"],
    color: "bg-amber-500",
    shape: "square",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Harina de Trigo Haz de Oros 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 4500,
        cantidadUso: 100,
        unidadUso: "g",
      },
      {
        nombre: "Huevos AA Kikes x30",
        cantidadCompra: 30,
        unidadCompra: "unidad",
        costoCompra: 14500,
        cantidadUso: 2,
        unidadUso: "unidad",
      },
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 120,
        unidadUso: "ml",
      },
      {
        nombre: "Mantequilla Alpina 250g",
        cantidadCompra: 250,
        unidadCompra: "g",
        costoCompra: 7200,
        cantidadUso: 30,
        unidadUso: "g",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 30,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Banana Split",
    marca: "Casa",
    costo: 0,
    precio: 16900,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "copa",
    ubicacionFisica: "Barra de helados",
    proveedor: "Producción propia",
    tiempoEntrega: "5 min",
    descripcionLarga:
      "Banano abierto con tres bolas de helado (vainilla, fresa, chocolate), crema batida, salsa de chocolate, fresas y cerezas.",
    especificaciones: [
      { clave: "Bolas helado", valor: "3" },
      { clave: "Tiempo prep", valor: "5 min" },
    ],
    imageKeywords: ["banana-split", "ice-cream-sundae", "classic-dessert"],
    color: "bg-yellow-500",
    shape: "diamond",
    gastoMargen: "ambicioso",
    destacado: true,
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Banano Común 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 1600,
        cantidadUso: 200,
        unidadUso: "g",
      },
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 200,
        unidadUso: "ml",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 100,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 80,
        unidadUso: "g",
      },
      {
        nombre: "Fresa Fresca 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 4800,
        cantidadUso: 100,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Cheesecake de Fresa",
    marca: "Casa",
    costo: 0,
    precio: 11900,
    stock: 32,
    stockMinimo: 10,
    stockMaximo: 60,
    unidad: "porción",
    ubicacionFisica: "Vitrina H2, postres fríos",
    proveedor: "Producción propia",
    tiempoEntrega: "Inmediato",
    descripcionLarga:
      "Cheesecake horneado con queso crema, base de galleta mantequillosa y topping de fresas frescas en almíbar.",
    especificaciones: [{ clave: "Vida útil", valor: "3 días refrigerado" }],
    imageKeywords: ["strawberry-cheesecake", "cheesecake", "dessert-slice"],
    color: "bg-pink-300",
    shape: "square",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 12,
    recetaIngredientes: [
      {
        nombre: "Queso Campesino Fresco 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 9800,
        cantidadUso: 500,
        unidadUso: "g",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 200,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 200,
        unidadUso: "g",
      },
      {
        nombre: "Huevos AA Kikes x30",
        cantidadCompra: 30,
        unidadCompra: "unidad",
        costoCompra: 14500,
        cantidadUso: 4,
        unidadUso: "unidad",
      },
      {
        nombre: "Mantequilla Alpina 250g",
        cantidadCompra: 250,
        unidadCompra: "g",
        costoCompra: 7200,
        cantidadUso: 100,
        unidadUso: "g",
      },
      {
        nombre: "Fresa Fresca 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 4800,
        cantidadUso: 400,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Arequipe con Brevas",
    marca: "Casa",
    costo: 0,
    precio: 9500,
    stock: 35,
    stockMinimo: 10,
    stockMaximo: 70,
    unidad: "porción",
    ubicacionFisica: "Vitrina H2, postres fríos",
    proveedor: "Producción propia",
    tiempoEntrega: "Inmediato",
    descripcionLarga:
      "Postre colombiano: brevas en almíbar bañadas en arequipe cremoso, acompañadas de queso campesino fresco.",
    especificaciones: [{ clave: "Tipo", valor: "Postre tradicional" }],
    imageKeywords: ["arequipe", "figs-caramel", "colombian-dessert"],
    color: "bg-amber-700",
    shape: "circle",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Leche Condensada La Lechera 395g",
        cantidadCompra: 395,
        unidadCompra: "g",
        costoCompra: 6200,
        cantidadUso: 150,
        unidadUso: "g",
      },
      {
        nombre: "Queso Campesino Fresco 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 9800,
        cantidadUso: 40,
        unidadUso: "g",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 30,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Brownie con Helado",
    marca: "Casa",
    costo: 0,
    precio: 12900,
    stock: 35,
    stockMinimo: 10,
    stockMaximo: 70,
    unidad: "plato",
    ubicacionFisica: "Vitrina H2, postres fríos",
    proveedor: "Producción propia",
    tiempoEntrega: "2 min",
    descripcionLarga:
      "Brownie de chocolate tibio con bola de helado de vainilla, salsa de chocolate caliente y crema batida. Experiencia clásica.",
    especificaciones: [{ clave: "Montaje", valor: "Brownie + helado" }],
    imageKeywords: ["brownie-icecream", "chocolate-dessert", "sweet-treat"],
    color: "bg-amber-900",
    shape: "square",
    gastoMargen: "ambicioso",
    destacado: true,
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Brownie Chocolate",
        cantidadCompra: 1,
        unidadCompra: "unidad",
        costoCompra: 2800,
        cantidadUso: 1,
        unidadUso: "unidad",
      },
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 80,
        unidadUso: "ml",
      },
      {
        nombre: "Crema de Leche Alpina 200ml",
        cantidadCompra: 200,
        unidadCompra: "ml",
        costoCompra: 3800,
        cantidadUso: 60,
        unidadUso: "ml",
      },
      {
        nombre: "Azúcar Blanca Manuelita 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 3600,
        cantidadUso: 25,
        unidadUso: "g",
      },
    ],
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Smoothie Tropical",
    marca: "Casa",
    costo: 0,
    precio: 9900,
    stock: 45,
    stockMinimo: 12,
    stockMaximo: 90,
    unidad: "vaso",
    ubicacionFisica: "Barra de helados",
    proveedor: "Producción propia",
    tiempoEntrega: "3 min",
    descripcionLarga:
      "Smoothie cremoso de fresa, banano y yogurt griego con un toque de miel. Refrescante y nutritivo, sin azúcar añadida.",
    especificaciones: [
      { clave: "Volumen", valor: "400ml" },
      { clave: "Saludable", valor: "Sin azúcar añadida" },
    ],
    imageKeywords: ["fruit-smoothie", "smoothie-tropical", "healthy-drink"],
    color: "bg-pink-300",
    shape: "circle",
    gastoMargen: "ambicioso",
    esReceta: true,
    recetaRendimiento: 1,
    recetaIngredientes: [
      {
        nombre: "Fresa Fresca 500g",
        cantidadCompra: 500,
        unidadCompra: "g",
        costoCompra: 4800,
        cantidadUso: 120,
        unidadUso: "g",
      },
      {
        nombre: "Banano Común 1kg",
        cantidadCompra: 1000,
        unidadCompra: "g",
        costoCompra: 1600,
        cantidadUso: 150,
        unidadUso: "g",
      },
      {
        nombre: "Yogurt Griego Alpina 150g",
        cantidadCompra: 150,
        unidadCompra: "g",
        costoCompra: 2800,
        cantidadUso: 150,
        unidadUso: "g",
      },
      {
        nombre: "Leche Entera Alpina 1L",
        cantidadCompra: 1000,
        unidadCompra: "ml",
        costoCompra: 3200,
        cantidadUso: 100,
        unidadUso: "ml",
      },
    ],
  }),
];
